import { Component, OnInit, ChangeDetectorRef, AfterViewChecked, Input, ViewEncapsulation, Output, EventEmitter } from '@angular/core';
import { FormControl, FormGroup, FormArray, FormBuilder, Validators } from '@angular/forms';
import { Observable, merge } from 'rxjs';
import { Router, ActivatedRoute } from '@angular/router';
import { TasksService, DropdownsService, AuthenticationService } from 'app/services';
import { startWith, tap, switchMap, distinctUntilChanged, takeUntil } from 'rxjs/operators';
import { Subject } from 'rxjs';
import { forEach, includes, isEmpty, trim } from 'lodash';
import { GlobalFuntions } from 'app/_helpers';
import { TranslateService } from '@ngx-translate/core';
import { MatDialogRef } from '@angular/material/dialog';
import { TasksCreateModalComponent } from 'app/main/activities/tasks/tasks-create-modal/tasks-create-modal.component';
import { CrmMenuService } from 'app/services/crm-menu.service';
import { GetCommercialReferencePipe } from 'app/pipes/get-commercial-reference.pipe';
import { DatePipe } from '@angular/common';

@Component({
    selector: 'app-tasks-create-form',
    templateUrl: './tasks-create-form.component.html',
    styleUrls: ['./tasks-create-form.component.scss'],
    encapsulation: ViewEncapsulation.None,
    providers: [GetCommercialReferencePipe, DatePipe]
})
export class TasksCreateFormComponent implements OnInit, AfterViewChecked {

    @Output() openTimeline: EventEmitter<any>;
    @Input() modal: any;
    public searching: boolean;
    date = new Date().toISOString();
    offices: any;
    searchOffices$ = new Subject<string>();
    id: any;
    contactSearch: FormControl = new FormControl();
    searchAssignedTo$ = new Subject<string>();
    contacts: any;
    activity: FormGroup;
    viewRecord: boolean;
    tasks: any;
    filter: any;
    user: any;
    officeData: any;
    users: any;
    chiltItems: Observable<any[]>;
    task: FormArray;
    commercials: any;
    dossiers: any;
    clients: any;
    commercialSearch$ = new Subject<string>();
    dossierSearch$ = new Subject<string>();
    clientSearch$ = new Subject<string>();
    currentAgency: any;
    systemLang: any;

    private _unsubscribeAll: Subject<void> = new Subject<void>();
    constructor(
        private router: Router,
        private _tasksService: TasksService,
        private route: ActivatedRoute,
        private formBuilder: FormBuilder,
        private _dropdownsService: DropdownsService,
        private _authenticationService: AuthenticationService,
        private cdRef: ChangeDetectorRef,
        public _globalFuntions: GlobalFuntions, // for dateChange
        private _translateService: TranslateService,
        public matDialogRef: MatDialogRef<TasksCreateModalComponent>,
        public _crmMenuService: CrmMenuService,
        private datePipe: DatePipe
    ) {
        this._translateService.onLangChange.pipe(startWith('')).subscribe(() => {
            this.systemLang = this._translateService.currentLang === 'es' ? 'es_AR' : this._translateService.currentLang;
        });
        this.openTimeline = new EventEmitter();
        this.user = this._authenticationService.currentUserValue;
        this.officeData = this._authenticationService.currentOfficeValue;
        this.filter = {};
        this.filter.options = {
            page: 1,
            limit: 1000,
            sort: {
                value: 1
            }
        };
        this.filter.query = {
            status: 'Active'
        };
    }

    ngOnInit(): void {
        this._dropdownsService.getTaskTypes(this.filter).subscribe((data: any) => {
            this.tasks = data.docs;
        });
        // this._dropdownsService.getUsersByAgencies().subscribe((data: any) => {
        //   this.users = data.body;
        //   this.chiltItems = data.body;
        // });
        this.searchAssignedTo$
            .pipe(
                startWith(''),
                distinctUntilChanged(),
                takeUntil(this._unsubscribeAll),
                switchMap((search: string) => {
                    return this._dropdownsService.getAllAgencyUsers(search);
                }),
            )
            .subscribe((data: any) => {
                forEach(data, (value) => {
                    value.label = isEmpty(trim(value.full_name)) ? value.username : value.full_name;
                });
                this.users = data;
                this.chiltItems = data;
            });
        this.viewRecord = false;
        let officeRecord = false;
        if (includes(this.router.url, 'view')) {
            this.viewRecord = true;
            officeRecord = true;
        }

        if (this._globalFuntions.getUserRole(this.user.user_role)) {
            officeRecord = true;
        }

        this.activity = this.formBuilder.group({
            _id: [],
            subject: [{ value: '', disabled: this.viewRecord }, Validators.required],
            private: [{ value: '', disabled: this.viewRecord }],
            priority: [{ value: 'Normal', disabled: this.viewRecord }],
            status: [{ value: 'Open', disabled: this.viewRecord }],
            start_date: [{ value: this.date, disabled: this.viewRecord }],
            start_time: [{ value: this.date, disabled: this.viewRecord }],
            end_date: [{ value: this.date, disabled: this.viewRecord }],
            end_time: [{ value: this.date, disabled: this.viewRecord }],
            assignee_user: [{ value: 'None', disabled: this.viewRecord }],
            calendar_id: [{ value: 'None', disabled: this.viewRecord }],
            dependent_step: [{ value: 'None', disabled: this.viewRecord }],
            m_end: [],
            m_start: [],
            milestone: [{ value: 'None', disabled: this.viewRecord }],
            related_steps: [{ value: 'None', disabled: this.viewRecord }],
            sequence_id: [{ value: 'None', disabled: this.viewRecord }],
            steps: [{ value: 'None', disabled: this.viewRecord }],
            repeate_type: [{ value: 'None', disabled: this.viewRecord }],
            description: [{ value: '', disabled: this.viewRecord }],
            offices: [{ value: [this.officeData._id], disabled: officeRecord }, Validators.required],
            task_type: [{ value: '', disabled: this.viewRecord }],
            from: [{ value: this.user.user_name, disabled: this.viewRecord }],
            assignee: [{ value: [this.user._id], disabled: this.viewRecord }],
            task: this.formBuilder.array([this.createTask()]),
            contacts: [{ value: '', disabled: this.viewRecord }],
            task_type_value: this.formBuilder.group({
                en: (''),
                es_AR: ('')
            }),
            type: [{ value: 'task', disabled: false }],
            created_at: [{ value: '', disabled: false }],
            created_by: [{ value: '', disabled: false }],
            agency: [{ value: '', disabled: false }],
            color: [{ value: '', disabled: false }]
        });

        this.task = this.activity.get('task') as FormArray;
        this.currentAgency = this._authenticationService.currentAgencyValue;

        this.searchOffices$
            .pipe(
                startWith(''),
                switchMap((search: string) => {
                    return this._dropdownsService.getMeetingOffices(search);
                }),
            )
            .subscribe((data: any) => {
                this.offices = data.body;
            });

        merge(this.contactSearch.valueChanges)
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap(() => {
                    let search = this.contactSearch.value;
                    if (this.contactSearch.value) {
                        search = this.contactSearch.value;
                    }
                    return this._dropdownsService.getParticipants(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                this.contacts = data.body;
            });

        this.commercialSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    const searchFilter = {} as any;
                    if (search) {
                        const queryOr = [];
                        queryOr.push({ reference: Number(search) });
                        queryOr.push({ external_reference: { $regex: '.*' + search + '.*', $options: 'i' } });
                        queryOr.push({ other_reference: { $regex: '.*' + search + '.*', $options: 'i' } });
                        searchFilter.$or = queryOr;
                    }
                    return this._dropdownsService.getCommercialProperties(searchFilter);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                if (data) {
                    for (const value of data.body) {
                        value.label = value.reference +
                            ((value?.property_type_1_data?.value) ?
                                (' - ' + value.property_type_1_data.value[this.systemLang]) : '');
                    }
                    this.commercials = data.body;
                }
            });
        this.dossierSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    return this._dropdownsService.getDossiers(search);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                if (data.success) {
                    this.dossiers = data?.data?.map((dossier: any) => {
                        return {
                            ...dossier,
                            label: this.getDossierLabel(dossier)
                        };
                    });
                }
            });

        this.clientSearch$
            .pipe(
                startWith(''),
                tap(() => this.searching = true),
                switchMap((search: string) => {
                    const filter = { query: {} };
                    if (search) filter.query = { search };
                    return this._dropdownsService.getClients(filter);
                })
            )
            .subscribe((data: any) => {
                this.searching = false;
                if (data) {
                    for (const client of data.body) {
                        client.label = client.person_type === 'natural'
                            ? `${client.first_name || ''} ${client.last_name || ''}`.trim()
                            : client.commercial_name || '';
                    }
                    this.clients = data.body;
                }
            });

        this.id = this.route.snapshot.paramMap.get('id');
        if (this.id) {
            this._tasksService.getById(this.id).subscribe((data: any) => {
                // remove null values
                data = Object.entries(data).reduce((task, [key, value]) => {
                    if (value !== null) {
                        task[key] = value;
                    }
                    return task;
                }, {});
                this.activity.patchValue(data);
                this.patchFields(data);
            });
        }
        // Ticket # 1512
        // if (!this.id) {
        //     this.activity.get('end_time').valueChanges
        //         .subscribe((endTime: any) => {
        //             if (this.activity.get('start_date').value === this.activity.get('end_date').value) {
        //                 if (endTime instanceof Date) {
        //                     const date = cloneDeep(endTime);
        //                     date.setHours(date.getHours() - 1);
        //                     this.activity.get('start_time').setValue(date);
        //                 }
        //             }
        //         });
        // }
    }

    ngAfterViewChecked(): void {
        this.cdRef.detectChanges();
    }

    patchFields(data: any): void {
        this.clearFormArray(this.task);
        if (data.task && data.task.length) {
            forEach(data.task, (extra, key) => {
                this.task.push(this.createTask());
                this.activity.get('task.' + key).patchValue(extra);
            });
        } else {
            this.task.push(this.createTask());
        }
    }


    createTask(): FormGroup {
        return this.formBuilder.group({
            related_to: [{ value: '', disabled: this.viewRecord }],
            commercial_property: [{ value: '', disabled: this.viewRecord }],
            dossier: [{ value: '', disabled: this.viewRecord }],
            client: [{ value: '', disabled: this.viewRecord }],
        });
    }

    clearFormArray = (formArray: FormArray) => {
        while (formArray.length !== 0) {
            formArray.removeAt(0);
        }
    }

    getDossierLabel(dossier: any): string {
        const formattedDate = this.datePipe.transform(dossier.date_contract, 'dd/MM/yyyy');
        const parts = [
            dossier.dossier_id,
            formattedDate,
            dossier.dossier_description?.trim()
        ].filter(part => part); // Removes null, undefined, and empty strings

        return parts.join(' - ');
    }
}
